import  "./Links.css";
import React  from 'react';
import AllTours  from "./AllTours";
import Groups  from "./Groups";

const Links = React.memo(props => {
    if(props.layout == 'first'){
        return (
         <div className="toursWrap">
            {props.items.map((item,index) => (
                <AllTours item={item} key={"AllTours_"+index} linkTitle={props.linkTitle}/>
            )) }
            </div>
        );
    }
    else  if(props.layout == 'second'){
            return (
                <React.Fragment>
                 <div className="AllGroups">
                        {props.items.map((item,index) => (
                            <Groups item={item} key={"Groups_"+index} linkTitle={props.linkTitle} />
                    )) }
                 </div>
                  {(props.moreLink) &&
                   <div className="GrouplinkWrap allMuseums">
                    <a className="allMuseumsButton" href={props.moreLink} title={props.allMuseums}> 
                        <span> {props.allMuseums} </span>
                   </a>
                     </div>
                  }
                
                </React.Fragment>
            )
        }
});

export default Links;